import {
  ModuleRegistry,
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  CsvExportModule,
  provideGlobalGridOptions,
  RowSelectionModule,
  SelectEditorModule,
  NumberFilterModule,
  CellStyleModule,
  NumberEditorModule,
  TextEditorModule,
  QuickFilterModule,
  EventApiModule,
  ColumnAutoSizeModule,
  ColumnApiModule,
  TextFilterModule,
  DateFilterModule,
  RowAutoHeightModule,
  CustomEditorModule
} from 'ag-grid-community'
import { ClipboardModule, MenuModule, MultiFilterModule, RowGroupingModule, SetFilterModule } from 'ag-grid-enterprise'

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  ClipboardModule,
  CsvExportModule,
  MenuModule,
  MultiFilterModule,
  RowGroupingModule,
  SetFilterModule,
  RowSelectionModule,
  SelectEditorModule,
  NumberFilterModule,
  CellStyleModule,
  NumberEditorModule,
  TextEditorModule,
  QuickFilterModule,
  EventApiModule,
  ColumnAutoSizeModule,
  ColumnApiModule,
  TextFilterModule,
  DateFilterModule,
  RowAutoHeightModule,
  CustomEditorModule
])

// @todo: Need to validate the new theming options from ag-grid 33 and remove this
provideGlobalGridOptions({ theme: 'legacy' })
